import { AlertTriangle } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { ConflictInfo, formatConflictDescription } from "@/lib/offline/conflict-resolver";
import { formatActionDescription, PendingAction } from "@/lib/offline/action-queue";

interface ConflictDialogProps {
  conflict: ConflictInfo | null;
  action?: PendingAction;
  onOverwrite: () => void;
  onDiscard: () => void;
}

export function ConflictDialog({ 
  conflict, 
  action,
  onOverwrite, 
  onDiscard,
}: ConflictDialogProps) {
  if (!conflict) return null;

  return (
    <AlertDialog open={!!conflict}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            Tiedot muuttuneet
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>{formatConflictDescription(conflict)}</p>
            {action && (
              <p className="text-sm text-muted-foreground">
                Toiminto: {formatActionDescription(action)}
              </p>
            )}
            <p className="font-medium">
              Haluatko ylikirjoittaa palvelimen tiedot omilla muutoksillasi vai hylätä omat muutoksesi?
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onDiscard}>
            Hylkää omat muutokset
          </AlertDialogCancel>
          <AlertDialogAction onClick={onOverwrite}>
            Ylikirjoita palvelin
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
